module.exports = __webpack_public_path__ + "static/media/cat.f7a27198.png";